<template lang="pug">
list-manager.height-100(
  :errors="errors",
  :pages="pages",
  :page="page",
  :loading="loading",
  :next="nextPage",
  :prev="prevPage",
  :count="list.length"
)
  .container.grid-lg
    .columns
      .column.col-6.col-sm-12.my-2(v-for="mensagem in list")
        row(
          :mensagem="mensagem",
          @click="$router.push({ name: 'app.mensagens.enviada', params: { id: mensagem.id } })"
        )
  router-view
</template>

<script>
import parseErrors from "@/lib/errors/parseErrors";
import Row from "../Row";

export default {
  components: { Row },
  vuex: {
    "mensagens/enviadas": {
      state: ["list", "page", "status", "pages", "count"],
      actions: [
        "fetchList",
        "fetchRemove",
        "prevPage",
        "nextPage",
        "firstPage",
        "lastPage",
      ],
      getters: ["loading"],
      mutations: ["setQuery"],
    },
  },
  data() {
    return { q: { arquivada_remetente_eq: false }, errors: [] };
  },
  methods: {
    async listar() {
      try {
        this.setQuery({ ...this.q });
        await this.fetchList();
      } catch (e) {
        this.addErrors(parseErrors(e));
      }
    },
  },
  async created() {
    this.listar();
  },
};
</script>
